import { Text } from '@app-masters/react-lib';
import InteractionText from './interactionText';

const newMessage = ({title, content, type, from}) => {
    let interaction = {
        type: type,
        from: from,
        content: {subject: title, message: content},
        options: [{_id: 1, value: true, text: 'Continuar'}],
        action: {type: 'push', to: '/'}
    };
    return interaction;
};

const missionStart = ({userMission, numberOfQuestions}) => {
    if (!userMission) {
        userMission = {
            mission: {textualInteraction: 'ENEM'}
        };
    }
    const {visualInteraction, textualInteraction} = userMission.mission;
    switch (textualInteraction.toUpperCase()) {
    case 'ENEM':
        return enemWelcome(visualInteraction, numberOfQuestions);
    case 'TEST':
        return testWelcome(visualInteraction, numberOfQuestions);
    case 'OPORTUNITY_TEST':
        return opportunityTestWelcome(visualInteraction, numberOfQuestions);
    case 'EXERCISES_TRAINING':
        return exercisesWelcome(visualInteraction, numberOfQuestions);
    case 'EXERCISES_HELP':
        return exercisesHelpWelcome(visualInteraction, numberOfQuestions);
    case 'TEST_CORRECTION':
        return testCorrectionWelcome(visualInteraction, numberOfQuestions);
    case 'SUBSTITUTE_TEACHER':
        return testCorrectionHelpWelcome(visualInteraction, numberOfQuestions);
    case 'PRESENTATION':
        return presentationWelcome(visualInteraction, numberOfQuestions);
    case 'PRESENTATION_HELP':
        return presentationHelpWelcome(visualInteraction, numberOfQuestions);
    case 'PRESENTATION_CORRECTION':
        return presCorrectionWelcome(visualInteraction, numberOfQuestions);
    case 'PRESENTATION_AVALIATION':
        return presCorrectionHelpWelcome(visualInteraction, numberOfQuestions);
    default:
        return sessionWelcome(visualInteraction, numberOfQuestions);
    }
};

// Welcome Messages --
const enemWelcome = (visualInteraction, numberOfQuestions) => {
    const defaultType = 'EMAIL';
    const interaction = {
        type: visualInteraction || defaultType,
        from: 'ENEM - MEC',
        subject: 'Boa sorte!',
        message: InteractionText.enemWelcome(Math.ceil(numberOfQuestions / 2))
    };
    return newInteraction(interaction);
};

const testWelcome = (visualInteraction, numberOfQuestions) => {
    const interaction = {
        type: visualInteraction,
        from: 'Professor',
        subject: 'Prova da disciplina',
        message: InteractionText.testWelcome(Math.ceil(numberOfQuestions / 2))
    };
    return newInteraction(interaction);
};

const opportunityTestWelcome = (visualInteraction, numberOfQuestions) => {
    const interaction = {
        type: visualInteraction,
        from: 'Professor',
        subject: 'Prova para entrar',
        message: InteractionText.opportunityTestWelcome(Math.ceil(numberOfQuestions / 2))
    };
    return newInteraction(interaction);
};

const exercisesWelcome = (visualInteraction, numberOfQuestions) => {
    const interaction = {
        type: visualInteraction,
        from: 'Júlia - UFJF',
        subject: 'Por Favor!',
        message: InteractionText.exercisesWelcome(Math.ceil(numberOfQuestions / 2))
    };
    return newInteraction(interaction);
};

const exercisesHelpWelcome = (visualInteraction, numberOfQuestions) => {
    const interaction = {
        type: visualInteraction,
        from: 'José - UFJF',
        subject: 'Por Favor!',
        message: InteractionText.exercisesHelpWelcome(Math.ceil(numberOfQuestions / 2))
    };
    return newInteraction(interaction);
};

const testCorrectionWelcome = (visualInteraction, numberOfQuestions) => {
    const interaction = {
        type: visualInteraction,
        from: 'Aluno',
        subject: 'Correção das provas',
        message: InteractionText.testCorrectionWelcome(numberOfQuestions, Math.ceil(numberOfQuestions / 2))
    };
    return newInteraction(interaction);
};

const testCorrectionHelpWelcome = (visualInteraction, numberOfQuestions) => {
    const interaction = {
        type: visualInteraction,
        from: 'Professor',
        subject: 'Preciso de um favor!',
        message: InteractionText.testCorrectionHelpWelcome(numberOfQuestions, Math.ceil(numberOfQuestions / 2))
    };
    return newInteraction(interaction);
};

const presentationWelcome = (visualInteraction, numberOfQuestions) => {
    const interaction = {
        type: visualInteraction,
        from: 'Professor',
        subject: 'Apresentação',
        message: InteractionText.presentationWelcome(Math.ceil(numberOfQuestions / 2))
    };
    return newInteraction(interaction);
};

const presentationHelpWelcome = (visualInteraction, numberOfQuestions) => {
    const interaction = {
        type: visualInteraction,
        from: 'Professor',
        subject: 'Sobre a apresentação',
        message: InteractionText.presentationHelpWelcome(Math.ceil(numberOfQuestions / 2))
    };
    return newInteraction(interaction);
};

const presCorrectionWelcome = (visualInteraction, numberOfQuestions) => {
    const interaction = {
        type: visualInteraction,
        from: 'Aluno',
        subject: 'Sobre a apresentação',
        message: InteractionText.presCorrectionWelcome(Math.ceil(numberOfQuestions / 2))
    };
    return newInteraction(interaction);
};

const presCorrectionHelpWelcome = (visualInteraction, numberOfQuestions) => {
    const interaction = {
        type: visualInteraction,
        from: 'Professor',
        subject: 'Obrigado pela ajuda',
        message: InteractionText.presCorrectionHelpWelcome(Math.ceil(numberOfQuestions / 2))
    };
    return newInteraction(interaction);
};

const sessionWelcome = (visualInteraction, numberOfQuestions) => {
    const defaultType = 'EMAIL';
    const interaction = {
        type: visualInteraction || defaultType,
        from: 'Professor',
        subject: 'Atenção!',
        message: InteractionText.sessionWelcome(Math.ceil(numberOfQuestions / 2))
    };
    return newInteraction(interaction);
};

// Result Messages --
const missionResult = ({userMission, session}) => {
    if (!userMission) {
        userMission = {
            mission: {textualInteraction: 'ENEM'}
        };
    }
    const {visualInteraction, textualInteraction} = userMission.mission;
    switch (textualInteraction.toUpperCase()) {
    case 'ENEM':
        return enemResult(visualInteraction, session);
    case 'TEST':
        return testResult(visualInteraction, session);
    case 'OPORTUNITY_TEST':
        return opportunityTestResult(visualInteraction, session);
    case 'EXERCISES_TRAINING':
        return exercisesResult(visualInteraction, session);
    case 'EXERCISES_HELP':
        return exercisesHelpResult(visualInteraction, session);
    case 'TEST_CORRECTION':
        return correctionResult(visualInteraction, session);
    case 'SUBSTITUTE_TEACHER':
        return correctionHelpResult(visualInteraction, session);
    case 'PRESENTATION':
        return presentationResult(visualInteraction, session);
    case 'PRESENTATION_HELP':
        return presentationHelpResult(visualInteraction, session);
    case 'PRESENTATION_CORRECTION':
        return presCorrectionResult(visualInteraction, session);
    case 'PRESENTATION_AVALIATION':
        return presCorrectionHelpResult(visualInteraction, session);
    default:
        return sessionResult(session);
    }
};

const enemResult = (visualInteraction, session) => {
    const {correctCount, wrongCount, correctPercentage, whatsNext} = session;
    const totalCount = correctCount + wrongCount;

    let message = '';
    if (whatsNext.newLevel) {
        message = InteractionText.enemSuccess(correctCount, totalCount, correctPercentage * 10);
    } else {
        message = InteractionText.enemFail(correctCount, totalCount, correctPercentage * 10);
    }
    const interaction = {
        type: 'EMAIL',
        from: 'enem@mec.edu.br',
        subject: 'Resultado do ENEM',
        message
    };
    return newInteraction(interaction);
};

const testResult = (visualInteraction, session) => {
    const {correctCount, wrongCount, notAnsweredCount, correctPercentage} = session;
    const totalCount = correctCount + wrongCount + notAnsweredCount;

    let message = '';
    if (notAnsweredCount) {
        message = InteractionText.testIncomplete(
            (totalCount - notAnsweredCount),
            correctCount,
            totalCount, correctPercentage);
    } else {
        message = InteractionText.testComplete(correctCount, totalCount, correctPercentage);
    }
    const interaction = {
        type: visualInteraction,
        from: 'Professor - UFJF',
        subject: 'Resultado da prova',
        message
    };
    return newInteraction(interaction);
};

const opportunityTestResult = (visualInteraction, session) => {
    const {correctCount, wrongCount, notAnsweredCount, correctPercentage} = session;
    const totalCount = correctCount + wrongCount + notAnsweredCount;

    let message = '';
    if (notAnsweredCount) {
        message = InteractionText.opportunityTestIncomplete(
            (totalCount - notAnsweredCount),
            correctCount,
            totalCount, correctPercentage);
    } else {
        message = InteractionText.opportunityTestComplete(correctCount, totalCount, correctPercentage);
    }
    const interaction = {
        type: visualInteraction,
        from: 'Professor - UFJF',
        subject: 'Resultado da prova',
        message
    };
    return newInteraction(interaction);
};

const exercisesResult = (visualInteraction, session) => {
    const {correctCount, wrongCount} = session;
    const totalCount = correctCount + wrongCount;
    let message;
    if (wrongCount > 0) {
        message = InteractionText.exercisesNotPerfect(wrongCount, totalCount);
    } else {
        message = InteractionText.exercisesPerfect(totalCount);
    }
    const interaction = {
        type: visualInteraction,
        from: 'Julia - UFJF',
        subject: 'Exercicios',
        message
    };
    return newInteraction(interaction);
};

const exercisesHelpResult = (visualInteraction, session) => {
    const {correctCount, wrongCount} = session;
    const totalCount = correctCount + wrongCount;
    let message;
    if (wrongCount > 0) {
        message = InteractionText.exercisesHelpNotPerfect(wrongCount, totalCount);
    } else {
        message = InteractionText.exercisesHelpPerfect(totalCount);
    }
    const interaction = {
        type: visualInteraction,
        from: 'José - UFJF',
        subject: 'Exercicios',
        message
    };
    return newInteraction(interaction);
};

const presentationResult = (visualInteraction, session) => {
    const {wrongCount} = session;
    let message;
    if (wrongCount > 0) {
        message = InteractionText.presentationNotPerfect();
    } else {
        message = InteractionText.presentationPerfect();
    }
    const interaction = {
        type: visualInteraction,
        from: 'Professor - UFJF',
        subject: 'Resultado da apresentação',
        message
    };
    return newInteraction(interaction);
};

const presentationHelpResult = (visualInteraction, session) => {
    const {wrongCount} = session;
    let message;
    if (wrongCount > 0) {
        message = InteractionText.presentationHelpNotPerfect();
    } else {
        message = InteractionText.presentationHelpPerfect();
    }
    const interaction = {
        type: visualInteraction,
        from: 'Professor - UFJF',
        subject: 'Resultado da apresentação',
        message
    };
    return newInteraction(interaction);
};

const correctionResult = (visualInteraction, session) => {
    const {correctCount, wrongCount} = session;
    const totalCount = correctCount + wrongCount;
    let message;
    if (wrongCount > 0) {
        message = InteractionText.testCorrectionNotPerfect(wrongCount, totalCount);
    } else {
        message = InteractionText.testCorrectionPerfect(totalCount);
    }
    const interaction = {
        type: visualInteraction,
        from: 'Aluno',
        subject: 'Correção da prova',
        message
    };
    return newInteraction(interaction);
};

const correctionHelpResult = (visualInteraction, session) => {
    const {correctCount, wrongCount} = session;
    const totalCount = correctCount + wrongCount;
    let message;
    if (wrongCount > 0) {
        message = InteractionText.testCorrectionHelpNotPerfect(wrongCount, totalCount);
    } else {
        message = InteractionText.testCorrectionHelpPerfect(totalCount);
    }
    const interaction = {
        type: visualInteraction,
        from: 'Aluno',
        subject: 'Correção da prova',
        message
    };
    return newInteraction(interaction);
};

const presCorrectionResult = (visualInteraction, session) => {
    const {wrongCount} = session;
    let message;
    if (wrongCount > 0) {
        message = InteractionText.presCorrectionNotPerfect(wrongCount);
    } else {
        message = InteractionText.presCorrectionPerfect();
    }
    const interaction = {
        type: visualInteraction,
        from: 'Aluno',
        subject: 'Correção da apresentação',
        message
    };
    return newInteraction(interaction);
};

const presCorrectionHelpResult = (visualInteraction, session) => {
    const {wrongCount} = session;
    let message;
    if (wrongCount > 0) {
        message = InteractionText.presCorrectionHelpNotPerfect(wrongCount);
    } else {
        message = InteractionText.presCorrectionHelpPerfect(wrongCount);
    }
    const interaction = {
        type: visualInteraction,
        from: 'Aluno',
        subject: 'Correção da apresentação',
        message
    };
    return newInteraction(interaction);
};

const sessionResult = (visualInteraction, session) => {
    const {correctCount, wrongCount, notAnsweredCount, correctPercentage} = session;
    const totalCount = correctCount + wrongCount + notAnsweredCount;

    let message = '';
    if (notAnsweredCount) {
        message = InteractionText.sessionIncomplete(
            (totalCount - notAnsweredCount),
            correctCount,
            totalCount, correctPercentage);
    } else {
        message = InteractionText.sessionComplete(correctCount, totalCount, correctPercentage);
    }
    const interaction = {
        type: visualInteraction || 'EMAIL',
        from: 'Professor - UFJF',
        subject: 'Resultado da prova',
        message
    };
    return newInteraction(interaction);
};

// Other Interactions ---
const levelUp = (level) => {
    const {title} = level;
    const interaction = {
        type: 'LETTER',
        from: 'Reitoria da UFJF',
        subject: 'Parabéns pela aprovação!',
        message: InteractionText.levelUp(title)
    };
    return newInteraction(interaction);
};

const repeatLevel = (level) => {
    const {title} = level;
    const interaction = {
        type: 'LETTER',
        from: 'Reitoria da UFJF',
        subject: 'Notificação de reprovação',
        message: InteractionText.repeatLevel(title)
    };
    return newInteraction(interaction);
};

const newInteraction = ({type, from, message, subject}) => {
    return {
        type,
        from,
        content: {subject, message},
        options: [{_id: 1, value: true, text: 'Continuar'}]
    };
};

export {
    newInteraction,
    missionStart,
    missionResult,
    levelUp,
    repeatLevel,
    newMessage
};



// WEBPACK FOOTER //
// ./src/views/InteractionViews/interactions.js